export class Form {
    public static readonly Invalid = 'INVALID';
    public static readonly Valid = 'VALID';
    public static readonly DefaultGuid = '00000000-0000-0000-0000-000000000000';
}
